module.exports = __webpack_public_path__ + "img/mobControll.6116a151.png";